import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Zap, Heart, Linkedin } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AboutModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AboutModal({ open, onOpenChange }: AboutModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl gradient-primary flex items-center justify-center shadow-primary">
              <Zap className="w-5 h-5 text-primary-foreground" />
            </div>
            About DiscoRun AI
          </DialogTitle>
          <DialogDescription>Revolutionizing early payment discounts with AI</DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          <p className="text-foreground">
            DiscoRun AI is an intelligent platform that helps businesses optimize their working
            capital through smart early payment discount management. By leveraging AI, we
            automatically calculate optimal discount rates and streamline supplier communications.
          </p>

          <div className="border-t border-border pt-6">
            <h4 className="font-semibold text-foreground mb-4 flex items-center gap-2">
              <Heart className="w-4 h-4 text-destructive" />
              Meet Our Co-Founders
            </h4>

            <div className="grid grid-cols-2 gap-4">
              <div className="p-4 bg-muted rounded-lg text-center">
                <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-gradient-to-br from-primary to-primary/60 flex items-center justify-center text-2xl font-bold text-primary-foreground">
                  U
                </div>
                <h5 className="font-semibold text-foreground">Umang</h5>
                <p className="text-sm text-muted-foreground">Co-Founder</p>
                <Button variant="ghost" size="sm" className="mt-2" asChild>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                    <Linkedin className="w-4 h-4" />
                  </a>
                </Button>
              </div>

              <div className="p-4 bg-muted rounded-lg text-center">
                <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-gradient-to-br from-accent to-accent/60 flex items-center justify-center text-2xl font-bold text-primary-foreground">
                  R
                </div>
                <h5 className="font-semibold text-foreground">Rea</h5>
                <p className="text-sm text-muted-foreground">Co-Founder</p>
                <Button variant="ghost" size="sm" className="mt-2" asChild>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                    <Linkedin className="w-4 h-4" />
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
